<!-- background image -->
@if (!!model.data?.typeData?.pageBackgroundImage) {
<div class="_page-background-image scrollbar-none"
     style="height: 100vh !important">
     <img style="position:relative !important"
          [dfImage]="model.data.typeData.pageBackgroundImage"
          [priority]="true"
          ratio="auto"
          fill>
</div>
}
@switch (model.data.pageType) {
@case ('blog-post') {
<!-- blog post -->
<cms-blog-post-view [model]="model" />
}
@case ('blog-category') {
<!-- blog category -->
<cms-blog-category-view [model]="model" />
}
@case ('blog-root') {
<cms-blog-root-view [model]="model" />
}
@default {
<icms-outlet [components]="model.data.components"
             [name]="'Page content'" />
}
}